import { useState, useEffect } from "react";
import css from "./Details.module.css";
import Form from "../../../../Components/Form/Form";
import FormType from "../../../../Components/Form/FormType";
import { toast } from "react-toastify";
import Pictures from "../../../../Components/Form/Pictures/Pictures";
import Utils from "../../../../Services/Utills";

const CertModal = ({ onClose, onSave, existing, staffBiodata }) => {
	const [uploads, setUploads] = useState(
		existing?.id
			? [{ uploadId: existing.id, value: null, uploadType: "image/png" }]
			: []
	);
	const [isSaving, setIsSaving] = useState(false);
	const [options, setOptions] = useState(null);

	// Hardcoded expiry notification options
	const expiryNotificationOptions = [
		{ id: 60, label: "60 days before", value: 60 },
		{ id: 30, label: "30 days before", value: 30 },
		{ id: 7, label: "7 days before", value: 7 },
		{ id: 0, label: "On the day of expiry", value: 0 },
	];

	useEffect(() => {
		setOptions({
			Fields: [
				{
					element: FormType.Input,
					required: true,
					label: "Certificate Name",
					name: "name",
					value: existing?.name || "",
					placeholder: "Enter certificate name",
				},
				{
					element: FormType.DateOnly,
					required: true,
					label: "Expiration Date",
					name: "expirationDate",
					value: existing?.expirationDate || "",
				},
				{
					element: FormType.MultiSelectDropDown,
					name: "expiryNotifications",
					label: "Expiry Notification",
					options: expiryNotificationOptions,
					value: [],
					// toggleOption: { label: "Select All" },
				},
			],
		});
	}, [existing]);

	const isValidToSubmit = (data) =>
		data.name &&
		data.expirationDate &&
		uploads.length > 0 &&
		uploads.every((u) => u.uploadId);

	const formatDateToLong = (dateStr) => Number(dateStr.replace(/-/g, ""));

	const onSubmit = () => {
		if (isSaving || !options) return;

		const formData = Utils.FormObject(options);
		formData.uploads = uploads;

		if (!isValidToSubmit(formData)) {
			toast.error("Please fill all fields and upload certificate.");
			return;
		}

		setIsSaving(true);

		const payload = {
			id: staffBiodata?.id,
			firstname: staffBiodata?.firstname || "",
			lastname: staffBiodata?.lastname || "",
			email: staffBiodata?.email || "",
			phone: staffBiodata?.phone || "",
			docId: formData.uploads.map((u) => Number(u.uploadId)),
			docStatus: formData.uploads.map(() => 0),
			docExpirationDate: formData.uploads.map(() =>
				String(formatDateToLong(formData.expirationDate))
			),
			docName: formData.uploads.map(() => String(formData.name)),
			// Currently not sent to backend, just for frontend preview
			expiryNotifications: formData.expiryNotifications || [],
		};


		onSave(payload);
		setIsSaving(false);
	};

	if (!options) return null;

	return (
		<div className={css.ModalOverlay}>
			<div className={css.ModalContent}>
				<h3 className={css.ModalTitle}>
					{existing ? "Edit Certification" : "Add Certification"}
				</h3>

				{/* Form without built-in Save button */}
				<Form onSubmit={onSubmit}>{options}</Form>

				<div className={css.UploadSection}>
					<Pictures
						load={uploads}
						onChange={setUploads}
						onDelete={() => setUploads([])}
						allowedTypes={["image", "document"]}
					/>
				</div>

				{/* Both Save and Cancel beside each other */}
				<div className={css.ModalActions}>
					<button
						type="button"
						onClick={onClose}
						className={css.CancelBtn}
						disabled={isSaving}
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={onSubmit}
						className={css.SaveBtn}
						disabled={isSaving}
					>
						Save
					</button>
				</div>
			</div>
		</div>
	);
};

export default CertModal;
